export const formatDate = (date: string) => {
  const d = new Date(date)

  return d.toLocaleDateString('pt-BR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  })
}

export const formatDateTime = (date: string, opts: { showSeconds?: boolean } = { showSeconds: false }) => {
  const d = new Date(date)

  let formattedDate = `${d.toLocaleDateString()} ${d.toLocaleTimeString()}`

  if (!opts.showSeconds) {
    formattedDate = formattedDate.slice(0, -3)
  }

  return formattedDate
}

export const capitalize = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const formatNumber = (value: string, decimalPlaces = 2): string => {
  // Remove tudo que não é dígito ou vírgula
  let sanitized = value.replace(/[^\d,]/g, '')

  // Se houver mais de uma vírgula, mantém só a primeira
  const firstComma = sanitized.indexOf(',')
  if (firstComma !== -1) {
    sanitized = sanitized.slice(0, firstComma + 1) + sanitized.slice(firstComma + 1).replace(/,/g, '')
  }

  // Se terminar com vírgula, retorna mantendo a vírgula
  // (já garantido que só há uma vírgula)
  const parts = sanitized.split(',')
  let integerPart = parts[0]
  let decimalPart = parts[1] || ''

  // Limita a quantidade de casas decimais
  decimalPart = decimalPart.slice(0, decimalPlaces)

  // Formata parte inteira com pontos
  integerPart = integerPart.replace(/^0+/, '') // remove zeros à esquerda
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.')

  // Monta resultado
  let result = integerPart
  if (sanitized.endsWith(',')) {
    result += ','
  } else if (decimalPart) {
    result += ',' + decimalPart
  }

  return result
}
